import { gql } from '@apollo/client'

export const GET_MESSAGE_TEMPLATES = gql`
  query {
    messageTemplates {
      template_id
      name
      message {
        message_template_id
        context_text
        mail_template
      }
    }
  }
`

export const GET_MAIL_TEMPLATES = gql`
  query {
    mailTemplates {
      mail_template
      name
      render
    }
  }
`
